<template>
  <div v-if="archived" class="archived-project-warning">
    <div class="warning-icon">⚠️</div>
    <div class="warning-content">
      <h3>{{ s__('ProjectSettings|Project Archived') }}</h3>
      <p>
        {{
          s__(
            'ProjectSettings|This project has been archived. All tasks are archived and notifications are disabled.'
          )
        }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { s__ } from '@/locale'

defineProps({
  archived: { type: Boolean, required: true },
})
</script>

<style scoped>
.archived-project-warning {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  margin-bottom: 16px;
  align-items: flex-start;
}

.warning-icon {
  font-size: 24px;
  flex-shrink: 0;
  margin-top: 2px;
}

.warning-content {
  flex: 1;
}

.warning-content h3 {
  margin: 0 0 8px 0;
  color: #856404;
  font-size: 16px;
  font-weight: 600;
}

.warning-content p {
  margin: 0;
  color: #856404;
  font-size: 14px;
  line-height: 1.5;
}
</style>
